import React from "react";

import { ReactComponent as FaqIcon } from "../../../../assets/images/Help/icon_section_faq.svg";
import common from "../common.module.scss";

import FaqContent from "./FaqContent";

const HelpFaqSection = () => {
  return (
    <section id="faq" className={common.section}>
      <p className={common.heading}>
        <span className={common.group}>
          <FaqIcon />
          よくあるご質問
        </span>
      </p>
      <p className={common.description}>
        困っている内容に近い項目を開いてご確認ください。
      </p>
      <div className={common.content}>
        <FaqContent />
      </div>
      <p className={common.description}>
        解決しない場合は、ページ下部の
        <a className={common.link} href="#contact">
          個別のお問い合わせ
        </a>
        をご利用ください。
      </p>
    </section>
  );
};

export default HelpFaqSection;
